module.exports = __webpack_public_path__ + "img/Banner-Pagina-Web.9a8ec8f0.png";